import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useListWhiteListQuery } from '../../redux/Api/WhitelistApiSlice'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateChannel from '../../components/WhitelistChannels/EditCreateChannel'
import { can } from '../../helpers/auth'
import NoPermission from '../pages/noPermission'
import { toast } from 'react-toastify'
import ShowWhiteListHistory from '../../components/WhitelistChannels/ShowWhiteListHistory'
import EditCreateChannelCustomers from '../../components/WhitelistChannels/EditCreateChannelCustomers'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import CustomersDropdown from '../../components/CustomersDropdown'

function WhitelistChannels () {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})
  const {
    data: whitelist,
    isLoading,
    error,
    isFetching
  } = useListWhiteListQuery({
    expand: ['customers', 'last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ordering: '-id',
    search: search || undefined,
    ...filters
  })
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)
  const [history, setHistory] = useState(false)
  const [holder, setHolder] = useState()

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Channel Name',
      dataIndex: 'channel_name',
      key: 'channel_name',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'Channel ID',
      dataIndex: 'channel_id',
      key: 'channel_id'
    },
    {
      title: 'Channel URL',
      dataIndex: 'channel_url',
      key: 'channel_url',

      filter: true,
      filterType: 'text'
    },
    {
      title: 'Customer',
      dataIndex: 'customers',
      key: 'customer_name',

      render: customers => (
        <p>{customers?.map(c => c.customer_name).join(', ')}</p>
      ),
      filter: true,
      filterComponent: CustomersDropdown
    },
    {
      title: 'Last Updated By',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => {
        const { last_updated_by } = record
        return last_updated_by
          ? `${last_updated_by.first_name} ${last_updated_by.last_name}`
          : ''
      }
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (text, record) => {
        return record.is_active ? 'Active' : 'Deactivated'
      }
    }
  ]

  if (can('change_whitelistchannel')) {
    columns.push({
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <div className='flex gap-2'>
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          </div>
          <div className='flex gap-2'>
            <button
              className='btn btn-outline-theme'
              onClick={() => handleShowHistory(record)}
            >
              History
            </button>
          </div>
        </div>
      )
    })
  }
  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleShowHistory = record => {
    setHolder(record)
    setHistory(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  const context = useContext(AppSettings)
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return function cleanUp () {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [])

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  if (!can('view_whitelistchannel')) {
    return <NoPermission />
  }

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {edit ? (
        <EditCreateChannel
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          channel={holder}
        />
      ) : null}

      {create ? (
        <EditCreateChannel
          state={'create'}
          open={create}
          setOpen={setCreate}
          channel={null}
        />
      ) : null}
      {history ? (
        <ShowWhiteListHistory
          open={history}
          setOpen={setHistory}
          channel={holder}
        />
      ) : null}
      <div className='flex mb-4'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <button
          className='btn btn-outline-theme ml-auto mb-4'
          onClick={() => setCreate(true)}
        >
          Add New Channel
        </button>
      </div>
      <br />
      {whitelist ? (
        <ReusableTable
          columns={columns}
          data={whitelist?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: whitelist?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      ) : null}
    </div>
  )
}

export default WhitelistChannels
